<template>
	<div class="ht-profile-user-bids">
		<Loading :active.sync="loading"></Loading>
		<b-table :data="bids" hoverable default-sort="finish" :paginated="false" per-page="-1" detail-key="id">
			<template slot-scope="props">
				<b-table-column field="id" :label="$t('SKU')">{{ props.row.Product.sku }}</b-table-column>
				<b-table-column field="name" :label="$t('Product name')">
					<a v-bind:href="'/product/' + props.row.id" target="_blank">{{ props.row.Product.name }}</a>
				</b-table-column>
				<b-table-column field="status" :label="$t('Status')">
					<span
						v-if="props.row.status == 2"
						class="has-text-danger"
						>{{ $t('The product was deleted.') }}</span
					>
					<span
						v-else-if="0 < time.diff(props.row.finish) && 30 > time.diff(props.row.finish)"
						class="has-text-default">
						{{ $t("We're determining the winner. Please refresh the page.") }}
					</span>
					<span
						v-else-if="30 < time.diff(props.row.finish) && $store.getters.userid == props.row.winner_id"
						class="has-text-success"
						>{{ $t('You won the product.') }}</span
					>
					<span
						v-else-if="30 < time.diff(props.row.finish) && $store.getters.userid !== props.row.winner_id"
						class="has-text-danger"
						>{{ $t('You did not win the product.') }}</span
					>
					<span v-else>{{ $t('in progress') }}</span>
				</b-table-column>
				<b-table-column field="price" :numeric="true" :label="$t('Price')">{{
					props.row.price | toUserCurrency($data._this)
				}}</b-table-column>
			</template>
		</b-table>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay'

export default {
	components: {
		Loading,
	},
	data() {
		return {
			loading: true,
			bids: [],
			showDetailsIcon: null,
			total: 0,
			total_commission: 0,
			total_all: 0,
			checkOutTotal: 0,
			time: this.$moment(),
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
		}
	},
	props: {
		selectAuction: null,
		selectedTab: {
			type: Number,
			default: 0,
		},
		seller: {
			type: Boolean,
			default: false
		},
		winner: {
			type: Boolean,
			default: false
		},
		refresh: null,
	},
	mounted() {
		this.fetchList()
		console.log('USER', this.$store.getters.userpref)
	},
	methods: {
		startPay: function () {
			var _this = this
			_this.loading = true
			this.$http
				.post('/order/start-pay')
				.then((response) => {
					console.log(response)
					_this.loading = false
				})
				.catch((err) => {
					_this.loading = false
					console.log(err)
				})
		},
		total_price: function (rows, _this) {
			_this.total = 0
			_this.total_commission = 0
			_this.total_all = 0
			Object.entries(rows).forEach(([value, index]) => {
				_this.total_all += index.price_with_commission
				_this.total += index.price
				_this.total_commission += index.commission
			})
		},
		fetchList: function () {
			var _this = this
			_this.loading = true
			var path = '/self-bids/' + _this.selectAuction
			_this.$http.get(path).then((response) => {
				_this.bids = response.data.bids
				_this.loading = false
			})
		},
	},
	watch: {
		selectedTab: function (newVal) {
			if (newVal == 1) {
				this.fetchList()
			}
		},
		selectAuction: function () {
			console.log('won-bids')
			this.fetchList()
		},
		bids: function (newVal) {
			this.total_price(newVal, this)
			this.checkedRows = []
		},
		refresh: function () {
			if (this.selectedTab == 1) {
				this.fetchList()
			}
		},
	},
}
</script>
<style>
.table a {
	text-decoration: underline;
}
</style>
